// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"03a5a669","228":"03a5a669","331":"03a5a669","339":"03a5a669","362":"03a5a669","442":"03a5a669","446":"03a5a669","791":"03a5a669"}[chunkId] + ".chunk.css";
};